/** Company tenant context for dashboard onboarding */
export const companyTenantContext = {
  onboardingComplete: false,
  onboardingItems: [
    { id: 'microsoft', label: 'Connect Microsoft', done: false, linkKey: 'integrations' },
    { id: 'google', label: 'Connect Google', done: false, linkKey: 'integrations' },
    { id: 'whatsapp', label: 'Connect WhatsApp', done: false, linkKey: 'integrations' },
    { id: 'teams_app', label: 'Upload Teams App', done: false, linkKey: 'channels' },
    { id: 'test_booking', label: 'Run Test Booking', done: false, linkKey: 'meetings' },
  ],
};

export const tenantDashboardKPIs = {
  todayMeetings: 42,
  pendingMOMApprovals: 7,
  failedBookings: 2,
  connectedChannels: 2,
  upcomingReminders: 18,
};

export const dashboardCharts = {
  meetingsByDepartment: [
    { department: 'Sales', count: 18 },
    { department: 'Engineering', count: 24 },
    { department: 'HR', count: 8 },
    { department: 'Finance', count: 11 },
    { department: 'Operations', count: 15 },
    { department: 'Legal', count: 5 },
    { department: 'Marketing', count: 9 },
  ],
  channelUsage: [
    { channel: 'Teams', value: 55 },
    { channel: 'WhatsApp', value: 28 },
    { channel: 'Web', value: 17 },
  ],
};

export const needsAttentionItems = [
  {
    id: 'na-1',
    text: 'Google reconnect needed',
    urgency: 'high',
    resolveLink: 'integrations',
    resolveLabel: 'Integrations',
  },
  {
    id: 'na-2',
    text: '3 MOM approvals pending',
    urgency: 'medium',
    resolveLink: 'transcripts?status=pending',
    resolveLabel: 'Transcripts',
  },
  {
    id: 'na-3',
    text: '1 user invite not accepted',
    urgency: 'low',
    resolveLink: 'users',
    resolveLabel: 'Users',
  },
  {
    id: 'na-4',
    text: 'WhatsApp template review',
    urgency: 'medium',
    resolveLink: 'channels',
    resolveLabel: 'Channels',
  },
  {
    id: 'na-5',
    text: 'Room policy conflict — Boardroom A',
    urgency: 'critical',
    resolveLink: 'scheduling',
    resolveLabel: 'Scheduling',
  },
];

export const recentBookingsDashboard = [
  {
    id: 'rb-1',
    subject: 'Q1 Planning',
    organizer: 'Sara Al Hinai',
    startAt: new Date(new Date().setHours(10, 0, 0, 0)).toISOString(),
    channel: 'Teams',
  },
  {
    id: 'rb-2',
    subject: 'Vendor sync',
    organizer: 'Ali Al Balushi',
    startAt: new Date(new Date().setHours(11, 30, 0, 0)).toISOString(),
    channel: 'Google Meet',
  },
  {
    id: 'rb-3',
    subject: 'HR standup',
    organizer: 'Fatima Al Lawati',
    startAt: new Date(new Date().setHours(13, 0, 0, 0)).toISOString(),
    channel: 'Teams',
  },
  {
    id: 'rb-4',
    subject: 'Sales pipeline',
    organizer: 'Mohammed Al Riyami',
    startAt: new Date(new Date().setHours(14, 15, 0, 0)).toISOString(),
    channel: 'Web',
  },
  {
    id: 'rb-5',
    subject: 'IT review',
    organizer: 'Yousuf Al Kindi',
    startAt: new Date(new Date().setHours(16, 0, 0, 0)).toISOString(),
    channel: 'WhatsApp',
  },
];

export const remindersSummary = {
  total: 18,
  breakdown: [
    { type: 'Email', count: 8 },
    { type: 'Teams', count: 6 },
    { type: 'WhatsApp', count: 4 },
  ],
};

const mkMeeting = (i, hour, status, opts = {}) => {
  const start = new Date();
  start.setHours(hour, (i % 2) * 30, 0, 0);
  const end = new Date(start);
  end.setMinutes(end.getMinutes() + 45);
  return {
    id: `sch-${i}`,
    subject: `Meeting ${i + 1}: ${['Standup', 'Review', 'Workshop', '1:1'][i % 4]}`,
    startAt: start.toISOString(),
    endAt: end.toISOString(),
    organizer: `organizer${i}@acme.example`,
    organizerName: `Organizer ${i + 1}`,
    status,
    provider: i % 3 === 0 ? 'Teams' : i % 3 === 1 ? 'Google Meet' : 'Web',
    channel: i % 3 === 0 ? 'Teams' : i % 3 === 1 ? 'Google Meet' : 'Web',
    attendeeCount: 3 + (i % 8),
    joinUrl: `https://meet.example.com/${i}`,
    room: i % 4 === 0 ? `Room ${(i % 5) + 1}` : null,
    organizerJoined: status !== 'in-progress' || i % 7 !== 0,
    ...opts,
  };
};

/** Rich schedule rows for Today / Week views */
export const scheduleMeetingsSeed = [
  mkMeeting(0, 8, 'past'),
  mkMeeting(1, 9, 'scheduled'),
  mkMeeting(2, 10, 'in-progress'),
  mkMeeting(3, 11, 'scheduled'),
  mkMeeting(4, 12, 'cancelled'),
  mkMeeting(5, 14, 'scheduled'),
  mkMeeting(6, 15, 'scheduled'),
  mkMeeting(7, 17, 'past'),
  mkMeeting(8, 18, 'scheduled'),
];

export const scheduleSidebar = {
  roomCapacity: [
    { room: 'Boardroom A', capacity: 12, booked: 8 },
    { room: 'Huddle 2', capacity: 6, booked: 6 },
    { room: 'VC Suite', capacity: 20, booked: 5 },
  ],
  remindersDue: [
    { id: 'r1', label: 'Standup — 15m reminder', fireAt: new Date(new Date().setHours(9, 45, 0, 0)).toISOString() },
    { id: 'r2', label: 'Vendor sync — 1h reminder', fireAt: new Date(new Date().setHours(10, 30, 0, 0)).toISOString() },
    { id: 'r3', label: 'HR standup — Teams card', fireAt: new Date(new Date().setHours(12, 50, 0, 0)).toISOString() },
  ],
  delayedJoins: [
    { meetingId: 'sch-2', subject: 'Meeting 3: Workshop', startedAt: new Date(new Date().setHours(10, 0, 0, 0)).toISOString() },
  ],
};

export const actionCenterItemsSeed = Array.from({ length: 12 }, (_, i) => {
  const priority = ['critical', 'high', 'medium', 'low'][i % 4];
  const mod = ['Meetings', 'Integrations', 'Users', 'MOM'][i % 4];
  return {
    id: `ac-${i}`,
    priority,
    item: [
      'Approve MOM for Q1 review',
      'Reconnect WhatsApp Business',
      'Resolve double-booked room',
      'User license over limit',
      'Failed webhook delivery',
    ][i % 5],
    module: mod,
    dueAt: new Date(Date.now() + (i - 2) * 7200000).toISOString(),
    owner: i % 3 === 0 ? null : `admin${i % 4}@acme.example`,
    resolved: false,
    autoCloseKey: i % 6 === 0 ? 'integration_ok' : null,
    suggestedStep:
      mod === 'Integrations'
        ? 'Open Integrations and complete OAuth reconnect for the affected provider.'
        : mod === 'MOM'
          ? 'Open Transcripts & MOM and approve or request changes.'
          : 'Review the linked resource and apply the recommended fix.',
    deepLink:
      mod === 'Meetings'
        ? 'meetings'
        : mod === 'Integrations'
          ? 'integrations'
          : mod === 'Users'
            ? 'users'
            : 'transcripts',
  };
});

/** Legacy flat list shape kept for any old imports */
export const actionCenterItems = actionCenterItemsSeed.map((x) => ({
  id: x.id,
  title: x.item,
  severity: x.priority === 'critical' ? 'high' : x.priority,
  dueAt: x.dueAt,
  deepLink: `/${x.deepLink}`,
}));

export const todaysSchedule = scheduleMeetingsSeed.slice(0, 8).map((m) => ({
  id: m.id,
  title: m.subject,
  start: m.startAt,
  end: m.endAt,
  organizer: m.organizer,
  channel: m.channel,
  room: m.room,
}));
